module.exports = __webpack_public_path__ + "static/media/Surfing Time.c761c7f1.jpg";